import React, { useEffect, useState } from 'react'
import { postSuministrosEnUnPaquete } from '../../../services/PaginaRuta'
import TablaVerLosSuministrosEnUnPaquete from './TablaVerLosSuministrosEnUnPaquete'
import Loading from '../../Loading'

const ModalVerLosSuministrosEnUnPaquete = ({setmodalOnSuministrosEnUnPaquete, item}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [dataSuministrosEnunPaquete, setdataSuministrosEnunPaquete]=useState([])
    const [validateDeleteSuministro, setvalidateDeleteSuministro]=useState(false)
    const [actualizarTablaSuministros, setactualizarTablaSuministros]=useState('')
    const [loading, setloading]=useState(true)

    const passActualizarTablaSuministro=(data)=>{
      setactualizarTablaSuministros(data)
    }
    
    const handleCancelClick=()=>{
        setmodalOnSuministrosEnUnPaquete(false)
    }

    useEffect(()=>{
      //console.log(item,'infoooooo')
      setloading(false)
        const body={
            varProEmpCod:usuarioInfo.Empresa,
            varProMCDpto:usuarioInfo.Sede,
            varProCirCod: item.ProCirCod,
            varPaqCod: item.PaqCod,
            //varProCirCod: item.ProCirCod,
            //varPaqCod:item.PaqCod,
        }
        //console.log(body,'bodyyy')
        postSuministrosEnUnPaquete(body).then((res)=>{
          setloading(true)
            setdataSuministrosEnunPaquete(res.data)
            //setinfoPaquete(res.data[0])
            //console.log(res.data,'suministro en un paquete')
        })

        //console.log(item.PaqDes,'item.PaqDes')
        //clinica cartagena
        // const paqueteGenericoCodigo = '39'
        

        //produccion pruebas 
        // const paqueteGenericoCodigo = '94'

        //clinica estancia
        // const paqueteGenericoCodigo = 'GER'

        //variable de entorno
        //const paqueteGenericoCodigo = process.env.REACT_APP_PAQUETE_GENERICO_ID

        // if(parseInt(item.PaqCod) === parseInt(paqueteGenericoCodigo)){
          if(item.PaqInd.trim() === 'G'){
          //console.log('hola')
          setvalidateDeleteSuministro(true)
        }

    },[actualizarTablaSuministros])

  return (
    <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
          <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Selección de Paquetes y Suministros 
              </h5>
              <button
                type="button"
                onClick={handleCancelClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <form>
              <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      N° Cirugía
                    </label>
                    <input
                    defaultValue={item.ProCirCod}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Numero del Paquete
                    </label>
                    <input
                    defaultValue={item.PaqCod}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Paquete
                    </label>
                    <input
                    defaultValue={item.PaqDes}
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
              </div>
              
            </form>
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-4 inline-block min-w-full sm:px-6 ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center">
                        <thead className="border-b bg-gray-200">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              
                            </th>
                          
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              Suministros
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              Comercial
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              Cantidad Solicitada
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              Cantidad Despachada
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              Concentración
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-4"
                            >
                              Forma
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            loading?
                            dataSuministrosEnunPaquete.map((item,index)=>(
                                <TablaVerLosSuministrosEnUnPaquete key={index} item={item} validateDeleteSuministro={validateDeleteSuministro} passActualizarTablaSuministro={passActualizarTablaSuministro}/>
                            ))
                            :
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><Loading/></td>
                            </tr>
                          }
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button type="button"
              onClick={handleCancelClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal">
              Cerrar
              </button>
              {/* <button
                type="submit"
                //onClick={handleClickDataCirugia}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Guardar
              </button> */}
            </div>
          </div>
        </div>
      </div>
  )
}

export default ModalVerLosSuministrosEnUnPaquete